# GraphQL fragment to enable/disable Office365 calendar email sync
#import "../fragments/user-email-fragment.graphql"

mutation setOffice365MailSendIsEnabled($isEnabled: Boolean!) {
    setOffice365MailSendIsEnabled(input: {mailSync: {isEnabled: $isEnabled}}) {
        authUrl
        emailAddresses {
            ...UserEmail
        }
    }
}
